/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row } from 'reactstrap'

const ReviewedProductStatus = ({ item }) => {
  const [reviewStatus, setReviewStatus] = useState({
    ReviewerOneFN: '',
    ReviewerOneLN: '',
    ReviewOneStatus: '',
    ReviewerTwoFN: '',
    ReviewerTwoLN: '',
    ReviewTwoStatus: '',
  })

  useEffect(() => {
    if (item) {
      console.log('item is: ' + JSON.stringify(item))
      const {
        ReviewerOneFN,
        ReviewerOneLN,
        ReviewOneApproved,
        ReviewerTwoFN,
        ReviewerTwoLN,
        ReviewTwoApproved,
      } = item
      setReviewStatus({
        ReviewerOneFN: ReviewerOneFN ?? '',
        ReviewerOneLN: ReviewerOneLN ?? '',
        ReviewOneStatus: ReviewOneApproved ?? '',
        ReviewerTwoFN: ReviewerTwoFN ?? '',
        ReviewerTwoLN: ReviewerTwoLN ?? '',
        ReviewTwoStatus: ReviewTwoApproved ?? '',
      })
    }
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>Reviewer One</p>
          <Input
            name="ReviewerOne"
            value={
              reviewStatus.ReviewerOneFN + ' ' + reviewStatus.ReviewerOneLN
            }
            disabled
          />
          <br />
          <p>Review One Status</p>
          <Input
            name="ReviewOneStatus"
            defaultValue={reviewStatus.ReviewOneStatus}
            disabled
          />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>Reviewer Two</p>
          <Input
            name="ReviewerTwo"
            value={
              reviewStatus.ReviewerTwoFN + ' ' + reviewStatus.ReviewerTwoLN
            }
            disabled
          />
          <br />
          <p>Review Two Status</p>
          <Input
            name="ReviewTwoStatus"
            defaultValue={reviewStatus.ReviewTwoStatus}
            disabled
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default ReviewedProductStatus
